import React from 'react';
import { ChevronDown, ChevronUp } from '../Icon';

type Props = {
    header: React.ReactNode;
    children: React.ReactNode;
    open: boolean;
    onToggle: (value: boolean) => void;
};

function Expandable({ header, children, open, onToggle }: Props) {
    return (
        <div className="relative mb-4 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-[0_10px_30px_rgba(15,23,42,0.05)]">
            <div
                onClick={() => onToggle(!open)}
                className="cursor-pointer bg-white px-4 py-3 pr-10"
                tabIndex={0}
                role="button"
                onKeyDown={(e) => e.key === 'Enter' && onToggle(!open)}
            >
                {header}
            </div>
            {open ? (
                <ChevronUp className="pointer-events-none absolute right-4 top-4 z-10 h-4 w-4 text-slate-500" />
            ) : (
                <ChevronDown className="pointer-events-none absolute right-4 top-4 z-10 h-4 w-4 text-slate-500" />
            )}
            {open && (
                <div className="border-t border-slate-100 bg-slate-50/60 px-4 py-4">
                    {children}
                </div>
            )}
        </div>
    );
}

export default Expandable;
